import { InfoCard, StructuredMetadataTable } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { buildMetadata } from './annotations';

// Example/placeholder resource-type view: sandbox-lease-template resources
// (InnovationsandboxProvider#toTemplateEntity) get the same treatment as
// aws-sandbox-lease/-account. Copy this file + its registration in index.tsx
// to wire up another annotation-driven resource type.
export function TemplateDetailsCard() {
  const { entity } = useEntity();
  const metadata = buildMetadata(entity, [
    { label: 'Template Name', key: 'template-name' },
    { label: 'Duration (hours)', key: 'duration-hours' },
    { label: 'Max Spend', key: 'max-spend' },
    { label: 'Requires Approval', key: 'requires-approval' },
  ]);

  return (
    <InfoCard title="Template Details">
      <StructuredMetadataTable metadata={metadata} />
    </InfoCard>
  );
}
